// ProductPickerColors.ts

// // 1. Border Colors (Type-based)
// export const TYPE_BORDERS = {
//     Drink: '#0d6efd', // Bootstrap Blue
//     Snack: '#8B4513'  // SaddleBrown
// };
  
// // 2. Standard Palette (Bright/Original)
// export const STANDARD_PALETTE = {
//     'Classic':    { Drink: '#dc3545', Snack: '#fd7e14' }, // Red / Orange
//     'Healthy':    { Drink: '#198754', Snack: '#20c997' }, // Green / Teal
//     'Zero Sugar': { Drink: '#212529', Snack: '#6c757d' }, // Black / Grey
//     'Energy':     { Drink: '#0d6efd', Snack: '#0dcaf0' }, // Blue / Cyan
//     'Special':    { Drink: '#6610f2', Snack: '#d63384' }  // Indigo / Pink
// };

// // 3. Pastel Palette (Softer/Less Bright)
// export const PASTEL_PALETTE = {
//     'Classic':    { Drink: '#e57373', Snack: '#ffb74d' }, // Soft Red / Soft Orange
//     'Healthy':    { Drink: '#81c784', Snack: '#4db6ac' }, // Soft Green / Soft Teal
//     'Zero Sugar': { Drink: '#546e7a', Snack: '#78909c' }, // Blue Grey / Light Blue Grey
//     'Energy':     { Drink: '#64b5f6', Snack: '#4dd0e1' }, // Soft Blue / Soft Cyan
//     'Special':    { Drink: '#9575cd', Snack: '#f06292' }  // Soft Purple / Soft Pink
// };


// ProductPickerColors.ts

// 1. Border Colors (Type-based)
export const TYPE_BORDERS = {
    Drink: '#0d6efd', // Bootstrap Blue
    Snack: '#8B4513', // SaddleBrown
    Candy: '#d63384'  // Bootstrap Pink
};
  
// 2. Standard Palette (Bright/Original)
export const STANDARD_PALETTE = {
    'Classic':    { Drink: '#dc3545', Snack: '#fd7e14', Candy: '#dc3545' }, // Red / Orange / Red
    'Healthy':    { Drink: '#198754', Snack: '#20c997', Candy: '#198754' }, // Green / Teal / Green
    'Zero Sugar': { Drink: '#212529', Snack: '#6c757d', Candy: '#343a40' }, // Black / Grey / Dark Grey
    'Energy':     { Drink: '#0d6efd', Snack: '#0dcaf0', Candy: '#6610f2' }, // Blue / Cyan / Indigo
    'Special':    { Drink: '#6610f2', Snack: '#d63384', Candy: '#e83e8c' }  // Indigo / Pink / Pink
};

// 3. Pastel Palette (Softer/Less Bright)
export const PASTEL_PALETTE = {
    'Classic':    { Drink: '#e57373', Snack: '#ffb74d', Candy: '#ef9a9a' },
    'Healthy':    { Drink: '#81c784', Snack: '#4db6ac', Candy: '#a5d6a7' },
    'Zero Sugar': { Drink: '#546e7a', Snack: '#78909c', Candy: '#90a4ae' },
    'Energy':     { Drink: '#64b5f6', Snack: '#4dd0e1', Candy: '#9575cd' },
    'Special':    { Drink: '#9575cd', Snack: '#f06292', Candy: '#f48fb1' }
};